<template>
  <div>
    <p class="text-h6">重要なお知らせ</p>
    <v-alert
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      <div v-if="isLight" class="start-link">
        <a @click="openPDF('operation_process_light')">
          操作手順
        </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <a @click="openPDF('course_detail')">
          健チャレ冊子（PDF）
        </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <a @click="openPDF('operation_process')">
          WEB操作手順（PDF）
        </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <a @click="openPDF('for_smartphone_app')">
          健康チャレンジ専用スマートフォンアプリの使い方（PDF）
        </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <a @click="openPDF('about_point')">
          健チャレのポイントの加算方法
        </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <a @click="openPDF('prize_detail')">
          達成賞 比較表
        </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <a @click="openPDF('prize_acquisition_conditions')">
          達成賞および達成特典 獲得条件一覧
        </a>
      </div>

      <div v-if="!isLight" class="start-link">
        <span >PepUpの登録は</span>
          <a style="padding-left: 16px;" href="https://www.kenpo.gr.jp/nskenpo/contents/hoken/pepup/tetuduki.html" target="_blank">
            こちら
          </a>
      </div>
      <div v-if="!isLight" class="start-link">
        <span >※ユーザー登録後に記号番号が変わった方は</span>
        <a style="padding-left: 16px;" @click="openPDF('for_number_changed')">
          こちら
        </a>
      </div>
    </v-alert>

    <v-alert
      v-if="supportdesk"
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      <p>サポートデスク</p>
      <p style="white-space:pre-wrap;" v-text="supportdesk"></p>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      supportdesk: '',
      isMobileApp: false
    }
  },
  computed: {
    // 運用テストかどうか（健チャレLight版）
    isLight () {
      return process.env.VUE_APP_IS_LIGHT
    }
  },
  mounted () {
    this.getSupportdeskJson()
    this.isMobileApp = this.$store.getters.getIsMobileApp
  },
  methods: {
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    },
    // cloudfront→S3からjsonファイルのサポートデスク情報を取得(手動でS3にファイルを格納する)
    getSupportdeskJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/supportdesk.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const supportdeskObj = this.response
            me.supportdesk = supportdeskObj.description
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.start-link {
  display: block;
  padding: 6px 0;
}
</style>
